import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Button, CircularProgress } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { mobilizeiStoresService } from '../_services/mobilizei/stores.service';
import { formatFileName } from '../utils/format';

const useStyles = makeStyles(() => ({
  hidden: {
    display: 'none'
  },
  uploadCard: {
    border: '1px solid rgba(0, 0, 0, 0.12);'
  },
  loadingWrapper: {
    padding: '20px 0'
  },
  videoWrapper: {
    alignItems: 'center',
    backgroundColor: '#ededed',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12);',
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  },
  video: {
    height: 'auto',
    width: '100%'
  },
  button: {
    backgroundColor: '#FCFCFD',
    borderRadius: 0,
    width: '100%'
  }
}));

function VideoUploader(props) {
  const fileInputRef = useRef(null);

  const classes = useStyles();
  const platformId = useSelector(state => state.StoreReducer.platform);
  const storeId = useSelector(state => state.ThemeReducer.storeId);

  const [isLoading, setIsLoading] = useState(false);
  const [uploadedVideoUrl, setUploadedVideoUrl] = useState(props.videoUrl);

  useEffect(() => {
    setUploadedVideoUrl(props.videoUrl);
  }, [props.videoUrl]);

  function handleUploadChange(e) {
    const file = e.target.files[0];
    if (!file) {
      return;
    }

    // Limit file size to 10MB
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      alert('O vídeo deve ter no máximo 10MB.');
      e.target.value = null; // Reset input
      return;
    }

    setIsLoading(true);

    let video = document.createElement('video');
    const _URL = window.URL || window.webkitURL;

    video.preload = 'metadata';
    video.src = _URL.createObjectURL(file);
    video.onloadedmetadata = function() {
      window.URL.revokeObjectURL(video.src);

      let videoData = new FormData();
      videoData.append("video", file, formatFileName(file.name));

      mobilizeiStoresService.uploadFile(platformId, storeId, videoData)
        .then((response) => {
          onUploadSuccess(response?.fileUrl, video.videoHeight, video.videoWidth, video.duration);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };
  }

  function onUploadSuccess(downloadURL, height, width, duration) {
    setIsLoading(false);
    setUploadedVideoUrl(downloadURL);

    props.onUploadSuccess({
      height,
      url: downloadURL,
      width,
      duration
    });
  }

  return (
    <>
      <input
        accept="video/*"
        className={classes.hidden}
        onChange={handleUploadChange}
        ref={fileInputRef}
        type="file"
      />

      <p className={classes.imageTitle}>{props.label}</p>

      <div className={classes.uploadCard}>
        <div className={classes.videoWrapper}>
          {isLoading ?
            <div className={classes.loadingWrapper}>
              <CircularProgress color="primary"/>
            </div> :
            uploadedVideoUrl ?
              <video
                className={classes.video}
                src={uploadedVideoUrl}
                controls
              /> :
              <img
                alt=""
                className={classes.video}
                src={require('../_assets/images/video_placeholder_350_350.png')}
              />
          }
        </div>

        <Button
          className={classes.button}
          disableElevation
          onClick={() => fileInputRef.current.click()}
          startIcon={<FontAwesomeIcon icon={['fas', 'cloud-upload-alt']} />}
          variant="contained"
        >
          trocar vídeo
        </Button>
      </div>
    </>
  );
}

export default VideoUploader;